import _ = require("underscore");
import $ = require("jquery");
import Base = require("./base-view");
import Portal = require("portal-gis");
import template = require("../templates/symbology-template");
import Model = require("../models/base-model");
import Utils = require("../utils");

function delayRefreshView(view: View) {
    let refresh = () => view.render();
    return _.debounce(refresh, 500);
}

class View extends Base<Portal.MonikerSymbologyElement> {

    static about = `
The app/controls/legend uses this view to render the symbologies registered with the maplet.
    `;

    execute(options) {

        this.refreshItem = delayRefreshView(this);

        return super.execute(_.defaults(options, {
            template: template,
            className: "legend"
        }));
    }

    onRender() {
        super.onRender();
        $(".expando", this.$el).click(el => {
            $(el.target).toggleClass("closed");
        });
    }

    renderItem(item: Portal.MonikerSymbologyElement) {
        console.log(`render symbol: ${item.id}`);

        let q = Utils.byClass(`symbol-${item.id}`);
        let clicker = $(q);
        if (!clicker.length) {
            console.warn("cannot find symbol: ", q);
        }
        clicker.click(() => {
            this.trigger("symbology-selected", { symbology: item });
        });

    }

    refreshItem(model: Model<Portal.MonikerSymbologyElement>) {
        // re-assigned in execute method to do a delayed render
    }

}

export = View;